// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Data_Function_Uncurried from "../Data.Function.Uncurried/index.js";
var unsafeUnion = Data_Function_Uncurried.runFn2($foreign.unsafeUnionFn);
export {
    unsafeUnionFn
} from "./foreign.js";
export {
    unsafeUnion
};
//# sourceMappingURL=index.js.map
